import React, { Component } from "react";

import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import _ from "lodash";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import Multiselect from "react-widgets/lib/Multiselect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    editDetailsBtn: "Edit Details",
    groupDetailsHeader: "Edit Lock Group",
    groupNameHeader: "Lock Group Name",
    groupNamePlaceholder: "Enter Lock Group Name",
    groupDescriptionHeader: "Lock Group Description (optional)",
    groupDescriptionPlaceholder: "Enter Lock Group Description",
    addMembersHeader: "Select Locks",
    addMembersPlaceholder: "-Select Members-",
    removeMemberBtn: "Remove Member",
    nameHeader: "Lock Name",
    emailHeader: "Lock Serial No.",
    selectedMembersHeader: "Lock Group List",
    saveTitle: "Save",
    cancelTitle: "Cancel",
    noDataTitle: "There is no data to display",
    emailHeader1: "Lock Model",
    searchPlaceholder: "Search",
    loading: "Loading...",
    emptyFormAlert:
      "Please enter a lock group name and select at least 2 locks",
    enterNameAlert: "Please enter a lock group name",
    minimumLockAlert:
      "Please ensure that you have selected at least 2 locks to be added into the group",
    unableUpdateAlert: "Unable to update lock group details, please try again",
    nameExistsAlert: "Lock group name already exists",
    updateSuccessAlert: "Lock group details updated successfully",
  },
  ja: {
    editDetailsBtn: "詳細を編集",
    groupDetailsHeader: "グループ編集",
    groupNameHeader: "グループ名",
    groupNamePlaceholder: "グループ名入力",
    groupDescriptionHeader: "グループメモ（オプション）",
    groupDescriptionPlaceholder: "グループメモ入力",
    addMembersHeader: "メンバー選択",
    addMembersPlaceholder: "メンバーを選択",
    removeMemberBtn: "メンバーを削除",
    nameHeader: "名前",
    emailHeader: "Eメール",
    selectedMembersHeader: "グループメンバーリスト",
    saveTitle: "保存",
    cancelTitle: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    emailHeader1: "ロックモデル",
    searchPlaceholder: "検索",
    loading: "読み込み中...",
    emptyFormAlert:
      "ロック グループ名を入力し、少なくとも 2 つのロックを選択してください",
    enterNameAlert: "ロックグループ名を入力してください",
    minimumLockAlert:
      "グループに追加するロックを少なくとも 2 つ選択していることを確認してください",
    unableUpdateAlert:
      "ロック グループの詳細を更新できません、もう一度お試しください",
    nameExistsAlert: "ロックグループ名はすでに存在します",
    updateSuccessAlert: "ロックグループの詳細が正常に更新されました",
  },
  es: {
    editDetailsBtn: "Editar Detalles",
    groupDetailsHeader: "Editar Grupo de Candados",
    groupNameHeader: "Nombre del Grupo de Candados",
    groupNamePlaceholder: "Ingrese el Nombre del Grupo de Candados",
    groupDescriptionHeader: "Descripción del Grupo de Candados (opcional)",
    groupDescriptionPlaceholder: "Ingrese la Descripción del Grupo de Candados",
    addMembersHeader: "Seleccionar Candados",
    addMembersPlaceholder: "-Seleccionar Miembros-",
    removeMemberBtn: "Eliminar Miembro",
    nameHeader: "Nombre de la Candado",
    emailHeader: "Número de Serie de la Candado",
    selectedMembersHeader: "Lista de Grupos de Candados",
    saveTitle: "Guardar",
    cancelTitle: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    emailHeader1: "Modelo de Candado",
    searchPlaceholder: "Buscar",
    loading: "Cargando...",
    emptyFormAlert:
      "Ingrese un nombre de grupo de candados y seleccione al menos 2 candados",
    enterNameAlert: "Por favor ingresa un nombre de grupo de candados",
    minimumLockAlert:
      "Asegúrese de haber seleccionado al menos 2 candados para agregarlos al grupo",
    unableUpdateAlert:
      "No se pueden actualizar los detalles del grupo de candados, inténtelo de nuevo",
    nameExistsAlert: "El nombre del grupo de candados ya existe",
    updateSuccessAlert:
      "Los detalles del grupo de candados se actualizaron correctamente",
  },
});

export class LockGroupDetailsButton extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    var memberemailarray = [];
    var memberarray = [];
    _.map(row.groupMembers, (memberData) => {
      memberarray.push(memberData);
      memberemailarray.push(memberData.memberEmail);
    });

    var originalmemberarray = [];
    _.map(this.props.rowValue.groupMembers, (memberData) => {
      originalmemberarray.push(memberData);
    });

    var lockgrouparray = [];
    _.map(row.locks, (lockData) => {
      const eachLock = {
        shareMode: lockData.sharingMode,
        startDate: lockData.shareStartTime,
        endDate: lockData.shareEndTime,
        access: lockData,
        Name: lockData.Name,
        Password: lockData.Password,
        Type: lockData.Type,
        addedOn: lockData.addedOn,
        id: lockData.id,
        ip45SerialNumber: lockData.ip45SerialNumber,
        isOfflineLock: lockData.isOfflineLock,
        key: lockData.key,
        lastAccess: lockData.lastAccess,
        ownedBy: lockData.ownedBy,
        shareAccessToken: lockData.shareAccessToken,
        shareCount: lockData.shareCount,
        shareEndTime: lockData.shareEndTime,
        sharePermissionType: lockData.sharePermissionType,
        shareStartTime: lockData.shareStartTime,
        sharedBy: lockData.sharedBy,
      };
    });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      groupID: row.id,
      groupName: row.name,
      groupNameExist: false,
      groupDesc: row.desc,
      memberemaillistArray: [],
      groupsArrayList: [],
      selectedMember: memberarray,
      selectedMemberValue: memberemailarray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      prevSelectedMember: originalmemberarray,
      selectedlockgroup: lockgrouparray,
      locklistarray: [],
      lockgrouparray: [],
      loading: false,
    };

    this.handleGroupDetailsPopupOpen = this.handleGroupDetailsPopupOpen.bind(
      this
    );
    this.handleGroupDetailsPopupClose = this.handleGroupDetailsPopupClose.bind(
      this
    );
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupDescChange = this.handleGroupDescChange.bind(this);
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateGroupData = this.updateGroupData.bind(this);
    this.retrieveGroupDetails = this.retrieveGroupDetails.bind(this);
    this.unselectMember = this.unselectMember.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this
    );
    this.renderSelectMember = this.renderSelectMember.bind(this);
    this.filterSelectedMembers = this.filterSelectedMembers.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    var originalmemberarray = [];
    _.map(nextProps.rowValue.groupMembers, (memberData) => {
      originalmemberarray.push(memberData);
    });
    this.setState({
      cell: nextProps.cellValue,
      row: nextProps.rowValue,
      prevSelectedMember: originalmemberarray,
    });
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });

    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        var memberArr = [];
        var eachMember = {};
        tempArray = this.snapshotToArray(snapshot);
        tempArray.forEach((e) => {
          //! FIND MEMBER UID
          fire
            .database()
            .ref("registeredUsersOnPlatform")
            .orderByValue()
            .equalTo(e.friendEmail)
            .once("value")
            .then((snapshots) => {
              if (snapshots.exists()) {
                e["memberUID"] = Object.keys(snapshots.val())[0];

                eachMember = {
                  memberEmail: e.friendEmail,
                  memberName: e.friendName,
                  memberUID: e["memberUID"],
                  memberDisplay: e.friendName + " | " + e.friendEmail,
                };

                memberArr.push(eachMember);
              }
            });
        });
        this.setState({
          memberemaillistArray: memberArr,
        });
      });

    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        const tempArray = this.snapshotToArray(snapshot);
        this.setState({
          loading: false,
          locklistarray: tempArray,
        });
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;

      returnArr.push(item);
    });
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: (
        <div
          style={{
            whiteSpace: "normal",
            textAlign: "start",
            fontFamily: '"Nunito", sans-serif',
          }}
        >
          {msg}
        </div>
      ),
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  getLockModelName(type) {
    let lock = "Lock Model Unknown";
    if (type === 1) {
      lock = "Debossed Lock";
    } else if (type === 2) {
      lock = "TSA Travel Lock";
    } else if (type === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (type === 4) {
      lock = "IP45 Padlock";
    } else if (type === 10) {
      lock = "IP66 Padlock";
    } else if (type === 7 || type === 8 || type === 9) {
      lock = "Lock Out Tag Out";
    } else if (type === 11) {
      lock = "Anti-Cut Padlock";
    } else if (type === 12) {
      lock = "Heavy Duty Padlock";
    } else if (type === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }

  filterSelectedMembers(data) {
    // console.log(data);
    var filteredMemberListArray = data;
    for (var i = 0; i < filteredMemberListArray.length; i++) {
      const eachMember = filteredMemberListArray[i];
      for (var a = 0; a < this.state.selectedlockgroup.length; a++) {
        const eachSelectedMember = this.state.selectedlockgroup[a];
        if (eachMember.id === eachSelectedMember.id) {
          const index = this.state.locklistarray.indexOf(eachMember);
          // console.log(index);
          if (index > -1) {
            filteredMemberListArray.splice(index, 1);

            this.setState({
              locklistarray: filteredMemberListArray,
            });
          }
        }
      }
    }
    // console.log(this.state.memberemaillistArray);
    return this.state.locklistarray;
  }

  handleGroupDetailsPopupOpen() {
    fire
      .database()
      .ref("lockGroupManagement")
      .child(this.state.superAdminID)
      .child(auth.currentUser.uid)
      .child(this.state.groupID)
      .child("locks")
      .once("value")
      .then((snapshot) => {
        const lockObject = snapshot.val() || {};
        const serials = Object.values(lockObject);

        fire
          .database()
          .ref("userLocks")
          .child(auth.currentUser.uid)
          .orderByKey()
          .once("value")
          .then((snapshot) => {
            const tempArray = this.snapshotToArray(snapshot);
            const selectedLocks = tempArray.filter((lock) =>
              serials.includes(lock.ip45SerialNumber)
            );
            this.setState({
              showPopup: true,
              selectedlockgroup: selectedLocks,
            });
          });
        // console.log(selectedLocks);
      });
  }

  handleGroupDetailsPopupClose() {
    this.setState({
      showPopup: false,
      groupName: this.state.row.name,
      groupDesc: this.state.row.desc,
    });
  }

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }

  handleGroupDescChange(e) {
    this.setState({
      groupDesc: e.target.value,
    });
  }

  getVisibleRows() {
    if (!this.lockTable) return [];

    const allData = this.lockTable.props.data || [];
    const filteredData =
      typeof this.lockTable.getTableData === "function"
        ? this.lockTable.getTableData(true, true)
        : allData;

    const { page = 1, sizePerPage = 5 } = this.lockTable.state || {};

    const startIndex = (page - 1) * sizePerPage;
    const endIndex = startIndex + sizePerPage;

    const visibleRows = filteredData.slice(startIndex, endIndex);

    // console.log("Visible rows:", visibleRows);
    return visibleRows;
  }

  createCustomDeleteButton = (onBtnClick) => {
    return (
      <Button id="deleteMemberBtn" onClick={onBtnClick}>
        <i className="far fa-trash-alt" /> {localizationStrings.removeMemberBtn}
      </Button>
    );
  };

  customConfirmDialog(next) {
    next();
  }

  onAfterDeleteRow(emailDeleted) {
    var memberemailarray;
    var selectedMembers;

    memberemailarray = this.state.selectedMemberValue.filter(
      (value) => !emailDeleted.includes(value)
    );
    selectedMembers = this.state.selectedMember.filter(
      (value) => !emailDeleted.includes(value.memberEmail)
    );

    this.setState({
      selectedMember: selectedMembers,
      selectedMemberValue: memberemailarray,
    });
  }

  renderSelectMember(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.locklistarray;
            const selectedLockGroupList = this.state.selectedlockgroup;

            lockListArrayList.splice(lockListArrayList.indexOf(row), 1);
            selectedLockGroupList.push(row);

            // console.log(selectedLockGroupList);

            this.setState({
              locklistarray: lockListArrayList,
              selectedlockgroup: selectedLockGroupList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  unselectMember(cell, row) {
    return (
      <div>
        <button
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const lockListArrayList = this.state.locklistarray;
            const selectedLockGroupList = this.state.selectedlockgroup;

            lockListArrayList.push(row);
            selectedLockGroupList.splice(selectedLockGroupList.indexOf(row), 1);

            this.setState({
              locklistarray: lockListArrayList,
              selectedlockgroup: selectedLockGroupList,
            });
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  onSubmit() {
    this.setState({ loading: true });
    if (this.state.groupName != "" && this.state.selectedlockgroup.length > 1) {
      this.setState({
        groupNameExist: false,
      });
      this.updateGroupData(this.state.superAdminID);
    } else if (
      this.state.groupName == "" &&
      this.state.selectedlockgroup.length < 2
    ) {
      this.showNotification(
        localizationStrings.emptyFormAlert,
        "error",
        "tc",
        5
      );
      this.setState({ loading: false });
    } else if (this.state.groupName == "") {
      this.showNotification(
        localizationStrings.enterNameAlert,
        "error",
        "tc",
        5
      );
      this.setState({ loading: false });
    } else if (this.state.selectedlockgroup.length < 2) {
      this.showNotification(
        localizationStrings.minimumLockAlert,
        "error",
        "tc",
        5
      );
      this.setState({ loading: false });
    } else {
      this.showNotification(
        localizationStrings.unableUpdateAlert,
        "error",
        "tc",
        5
      );
      this.setState({ loading: false });
    }
  }

  async updateGroupData(superAdminID) {
    //fix
    //! CHECK IF GROUP NAME ALREADY EXISTS
    await fire // look for the original groupID
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          if (childData.name === this.state.row.name) {
            const groupID = childSnapshot.key;
            // console.log("Group ID:", groupID);
            this.setState({
              groupID: groupID,
            });
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    await fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          if (childSnapshot.key === this.state.groupID) {
            return; // Skip duplicate name check for the group that is being edited so same name can be used
          }

          const childData = childSnapshot.val();
          if (childData.name === this.state.groupName) {
            this.setState({ groupNameExist: true });
          }
        });
      });

    await fire // look for the original groupID
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          if (childData.name === this.state.row.name) {
            const groupID = childSnapshot.key;
            // console.log("Group ID:", groupID);
            this.setState({
              groupID: groupID,
            });
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    if (this.state.groupNameExist === true) {
      this.showNotification(
        localizationStrings.nameExistsAlert,
        "error",
        "tc",
        5
      );
      this.setState({ loading: false });
    } else {
      await fire
        .database()
        .ref("lockGroupManagement")
        .child(superAdminID)
        .child(auth.currentUser.uid)
        .child(this.state.groupID)
        .update({
          name: this.state.groupName,
          desc: this.state.groupDesc,
        });

      let groupMembersWithUID = {};

      for (var i = 0; i < this.state.selectedlockgroup.length; i++) {
        var eachLockGroupLock = this.state.selectedlockgroup[i];
        groupMembersWithUID[eachLockGroupLock.id] =
          eachLockGroupLock.ip45SerialNumber;
        // //old value
        // Name: eachLockGroupLock.Name,
        // Password: eachLockGroupLock.Password,
        // Type: eachLockGroupLock.Type,
        // addedOn: eachLockGroupLock.addedOn,
        // id: eachLockGroupLock.id,
        // ip45SerialNumber: eachLockGroupLock.ip45SerialNumber,
        // isOfflineLock: eachLockGroupLock.isOfflineLock,
        // key: eachLockGroupLock.key,
        // lastAccess: eachLockGroupLock.lastAccess,
        // ownedBy: eachLockGroupLock.ownedBy,
        // shareAccessToken: eachLockGroupLock.shareAccessToken,
        // shareCount: eachLockGroupLock.shareCount,
        // shareEndTime: eachLockGroupLock.shareEndTime,
        // sharePermissionType: eachLockGroupLock.sharePermissionType,
        // shareStartTime: eachLockGroupLock.shareStartTime,
        // sharedBy: eachLockGroupLock.sharedBy,
        // // Add other properties here if needed
      }
      await fire // look for the original groupID
        .database()
        .ref("lockGroupManagement")
        .child(superAdminID)
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((childSnapshot) => {
            const childData = childSnapshot.val();
            if (childData.name === this.state.row.name) {
              const groupID = childSnapshot.key;
              // console.log("Group ID:", groupID);
              this.setState({
                groupID: groupID,
              });
            }
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });

      await fire
        .database()
        .ref("lockGroupManagement")
        .child(superAdminID)
        .child(auth.currentUser.uid)
        .child(this.state.groupID)
        .update({
          locks: groupMembersWithUID,
        });

      // window.location.reload();
      await this.retrieveGroupDetails();

      this.props.dataCallBack(this.state.lockgrouparray);

      this.setState({
        showPopup: false,
        loading: false,
      });

      this.showNotification(
        localizationStrings.updateSuccessAlert,
        "success",
        "tc",
        5
      );
    }
  }

  async retrieveGroupDetails() {
    if (this.state.superAdminID !== "") {
      await fire
        .database()
        .ref("lockGroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            var dataWithKey = {
              id: childSnap.key,
              ...childSnap.val(),
            };
            tempArray.push(dataWithKey);
          });

          this.setState({
            lockgrouparray: tempArray,
            loading: false,
          });
        });
    }

    return this.state.lockgrouparray;
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <span
          onClick={this.handleGroupDetailsPopupOpen}
          style={{ fontSize: "1.5em" }}
          data-notify="icon"
          // className="pe-7s-pen"
          className="fas fa-pencil-alt"
          id="editDetailsIcon"
        ></span>
        {/* //! Popup for Group Details Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupDetailsPopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupDetailsHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <form>
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupNameHeader}
                </ControlLabel>
                <FormControl
                  type="text"
                  placeholder={localizationStrings.groupNamePlaceholder}
                  onChange={this.handleGroupNameChange}
                  value={this.state.groupName}
                ></FormControl>
              </FormGroup>
              <br />
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupDescriptionHeader}
                </ControlLabel>
                <FormControl
                  style={{ height: "100px" }}
                  componentClass="textarea"
                  placeholder={localizationStrings.groupDescriptionPlaceholder}
                  onChange={this.handleGroupDescChange}
                  value={this.state.groupDesc}
                />
              </FormGroup>
              <br />
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.addMembersHeader}
              </ControlLabel>
              <div className="selectMembersTable">
                <BootstrapTable
                  ref={(table) => (this.lockTable = table)} // ref to access pagination info
                  data={this.filterSelectedMembers(this.state.locklistarray)}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    searchField: this.createCustomSearchFieldForm,
                    defaultSortOrder: "asc", // default sort order
                    noDataText: localizationStrings.noDataTitle,
                  }}
                  search
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        justifyContent: "center",
                      }}
                    >
                      {/* Select Visible */}
                      {/* <Button
                        bsStyle="info"
                        bsSize="small"
                        style={{
                          padding: "2px 6px",
                          fontSize: "10px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          this.setState((prev) => {
                            const visibleRows = this.getVisibleRows();
                            const notYetSelected = visibleRows.filter(
                              (lock) =>
                                !prev.selectedlockgroup.some(
                                  (s) =>
                                    s.ip45SerialNumber === lock.ip45SerialNumber
                                )
                            );
                            return {
                              selectedlockgroup: [
                                ...prev.selectedlockgroup,
                                ...notYetSelected,
                              ],
                              locklistarray: prev.locklistarray.filter(
                                (lock) =>
                                  !notYetSelected.some(
                                    (n) =>
                                      n.ip45SerialNumber ===
                                      lock.ip45SerialNumber
                                  )
                              ),
                            };
                          });
                        }}
                      >
                        {localizationStrings.selectVisibleButton || "Visible"}
                      </Button> */}

                      {/* Select All */}
                      <Button
                        bsStyle="info"
                        bsSize="small"
                        style={{
                          padding: "2px 6px",
                          fontSize: "10px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          this.setState((prev) => {
                            const notYetSelected = prev.locklistarray.filter(
                              (lock) =>
                                !prev.selectedlockgroup.some(
                                  (s) =>
                                    s.ip45SerialNumber === lock.ip45SerialNumber
                                )
                            );
                            return {
                              selectedlockgroup: [
                                ...prev.selectedlockgroup,
                                ...notYetSelected,
                              ],
                              locklistarray: [],
                            };
                          });
                        }}
                      >
                        {localizationStrings.selectAllButton || "All"}
                      </Button>
                    </div>
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
              <div className="selectMembersTable">
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedlockgroup}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    noDataText: localizationStrings.noDataTitle,
                  }}
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="Name"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="ip45SerialNumber"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="Type"
                    dataFormat={this.getLockModelName}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader1}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {/* Unselect All */}
                    <Button
                      bsStyle="danger"
                      bsSize="xsmall"
                      onClick={() => {
                        this.setState((prev) => ({
                          locklistarray: [
                            ...prev.locklistarray,
                            ...prev.selectedlockgroup,
                          ],
                          selectedlockgroup: [],
                        }));
                      }}
                    >
                      {localizationStrings.unselectAllButton || "Unselect All"}
                    </Button>
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
              {/* <br /> */}
              <FormGroup style={{ display: "flex" }}>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={this.onSubmit}
                  disabled={this.state.loading}
                >
                  {this.state.loading
                    ? localizationStrings.loading
                    : localizationStrings.saveTitle}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={this.handleGroupDetailsPopupClose}
                >
                  {localizationStrings.cancelTitle}
                </Button>
              </FormGroup>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LockGroupDetailsButton;
